module.exports = __webpack_public_path__ + "img/tank-image.cbf6e8d4.jpg";